import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { DialogTitle } from "@material-ui/core";

const LimitConnectionTime = ({
  logout,
  limitConnectionTime,
  limitConnectionTimeCountdown,
  timeOutText
}) => {
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState(new Date());

  const [texts] = React.useState(timeOutText.split("||"));
  const [countdown, setCountdown] = React.useState(
    limitConnectionTimeCountdown
  );
  const showOpenLimitTimeRef = React.useRef(open);
  const dateRef = React.useRef(date);

  const handleCountdown = () => {
    const timer = setInterval(() => {
      if (showOpenLimitTimeRef.current === true) {
        setCountdown((prevCountdown) =>
          prevCountdown > 0 ? prevCountdown - 1 : prevCountdown
        );
      }
    }, 1000);

    return () => clearInterval(timer);
  };

  const handleOnConfirm = () => {
    setOpen(false);

    if (typeof logout === "function") {
      logout();
    }
  };

  const handleClose = () => {
    setDate(new Date());
    setOpen(false);
  };

  const handleOnCheckTimeOut = () => {
    if (limitConnectionTime) {
      const d = new Date();
      const v = Math.abs(d.getTime() - dateRef.current.getTime()) / 1000;

      if (v > limitConnectionTime && showOpenLimitTimeRef.current === false) {
        setCountdown(limitConnectionTimeCountdown);
        setOpen(true);
      }
    }
  };

  const handleOnCreateOnLimitConnectionTime = () => {
    if (limitConnectionTime) {
      handleCountdown();

      const interval = setInterval(() => {
        handleOnCheckTimeOut();
      }, 3000);

      return () => {
        if (interval) {
          clearInterval(interval);
        }
      };
    }
    return () => {};
  };

  React.useEffect(() => {
    return handleOnCreateOnLimitConnectionTime();
  }, [limitConnectionTime]);

  React.useEffect(() => {
    showOpenLimitTimeRef.current = open;
  }, [open]);

  React.useEffect(() => {
    dateRef.current = date;
  }, [date]);

  React.useEffect(() => {
    if (open === true && countdown === 0) {
      setDate(new Date());
      setOpen(false);
      if (typeof logout === "function") {
        logout();
      }
    }
  }, [open, countdown]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth="md"
        PaperProps={{ style: { width: 700 } }}
      >
        <DialogTitle
          style={{
            backgroundColor: "#0072bc",
            color: "#FFFFFF",
            textAlign: "center",
          }}
        >
          แจ้งเตือน
        </DialogTitle>
        <DialogContent style={{ paddingTop: 25 }}>
          <Grid container spacing={1}>
            {
              texts.map((txt) =>
                {
                  if(txt.indexOf('{minute}') > -1 && txt.indexOf('{secound}') > -1)
                  {
                    const txtMinutes = txt.split('{minute}')

                    const txtSecounds = txtMinutes[1].split('{secound}')

                    return <Grid item xs={12}>
                      <Typography align="center">{txtMinutes[0]} {Math.floor(countdown / 60)} {txtSecounds[0]} {countdown % 60} {txtSecounds[1]}</Typography>
                    </Grid>
                  }
                  else if(txt.indexOf('{minute}') > -1)
                  {
                    const txtMinutes = txt.split('{minute}')

                    return <Grid item xs={12}>
                      <Typography align="center">{txtMinutes[0]} {Math.floor(countdown / 60)} {txtMinutes[1]}</Typography>
                    </Grid>
                  }
                  else if(txt.indexOf('{secound}') > -1)
                  {
                    const txtSecounds = txt.split('{secound}')

                    return <Grid item xs={12}>
                      <Typography align="center">{txtSecounds[0]} {countdown} {txtSecounds[1]}</Typography>
                    </Grid>
                  }
                  else{
                    return <Grid item xs={12}>
                    <Typography align="center">{txt}</Typography>
                  </Grid>
                  }
                }
                
              )
            }
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", paddingBottom: 25 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <Button
                style={{ borderRadius: 20 }}
                color="primary"
                variant="contained"
                onClick={handleClose}
              >
                &nbsp;&nbsp;เข้าสู่ระบบต่อไป&nbsp;&nbsp;
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default LimitConnectionTime;
